import { render, staticRenderFns } from "./LayoutClinic.vue?vue&type=template&id=3cb98517&scoped=true&"
import script from "./LayoutClinic.vue?vue&type=script&lang=js&"
export * from "./LayoutClinic.vue?vue&type=script&lang=js&"
import style1 from "./LayoutClinic.vue?vue&type=style&index=1&id=3cb98517&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb98517",
  null
  
)

export default component.exports